// Generated via thermoimaging.thermoimaging Thermoimaging utilities.
// Temperature colorscale derived from create_custom_colormap_temp + matplotlib_to_plotly.
// Viscosity colorscale from create_plotly_colormap_viscosity.

export const TEMP_COLORSCALE: [number, string][] = [
  [0, "rgb(255, 255, 255)"],
  [0.003937007874015748, "rgb(251, 251, 251)"],
  [0.007874015748031496, "rgb(247, 247, 247)"],
  [0.011811023622047244, "rgb(243, 243, 243)"],
  [0.015748031496062992, "rgb(239, 239, 239)"],
  [0.01968503937007874, "rgb(235, 235, 235)"],
  [0.023622047244094488, "rgb(231, 231, 231)"],
  [0.027559055118110236, "rgb(227, 227, 227)"],
  [0.031496062992125984, "rgb(223, 223, 223)"],
  [0.03543307086614173, "rgb(219, 219, 219)"],
  [0.03937007874015748, "rgb(215, 215, 215)"],
  [0.04330708661417323, "rgb(211, 211, 211)"],
  [0.047244094488188976, "rgb(207, 207, 207)"],
  [0.051181102362204724, "rgb(203, 203, 203)"],
  [0.05511811023622047, "rgb(199, 199, 199)"],
  [0.05905511811023622, "rgb(195, 195, 195)"],
  [0.06299212598425197, "rgb(191, 191, 191)"],
  [0.06692913385826771, "rgb(187, 187, 187)"],
  [0.07086614173228346, "rgb(183, 183, 183)"],
  [0.07480314960629922, "rgb(179, 179, 179)"],
  [0.07874015748031496, "rgb(175, 175, 175)"],
  [0.0826771653543307, "rgb(171, 171, 171)"],
  [0.08661417322834646, "rgb(167, 167, 167)"],
  [0.09055118110236221, "rgb(163, 163, 163)"],
  [0.09448818897637795, "rgb(159, 159, 159)"],
  [0.09842519685039369, "rgb(155, 155, 155)"],
  [0.10236220472440945, "rgb(151, 151, 151)"],
  [0.1062992125984252, "rgb(147, 147, 147)"],
  [0.11023622047244094, "rgb(143, 143, 143)"],
  [0.11417322834645668, "rgb(139, 139, 139)"],
  [0.11811023622047244, "rgb(135, 135, 135)"],
  [0.1220472440944882, "rgb(131, 131, 131)"],
  [0.12598425196850394, "rgb(127, 127, 127)"],
  [0.12992125984251968, "rgb(123, 123, 123)"],
  [0.13385826771653542, "rgb(119, 119, 119)"],
  [0.1377952755905512, "rgb(114, 114, 114)"],
  [0.14173228346456693, "rgb(111, 111, 111)"],
  [0.14566929133858267, "rgb(107, 107, 107)"],
  [0.14960629921259844, "rgb(103, 103, 103)"],
  [0.15354330708661418, "rgb(98, 98, 98)"],
  [0.15748031496062992, "rgb(95, 95, 95)"],
  [0.16141732283464566, "rgb(91, 91, 91)"],
  [0.1653543307086614, "rgb(87, 87, 87)"],
  [0.16929133858267717, "rgb(82, 82, 82)"],
  [0.1732283464566929, "rgb(79, 79, 79)"],
  [0.17716535433070865, "rgb(75, 75, 75)"],
  [0.18110236220472442, "rgb(71, 71, 71)"],
  [0.18503937007874016, "rgb(66, 66, 66)"],
  [0.1889763779527559, "rgb(63, 63, 63)"],
  [0.19291338582677164, "rgb(59, 59, 59)"],
  [0.19685039370078738, "rgb(55, 55, 55)"],
  [0.20078740157480315, "rgb(50, 50, 50)"],
  [0.2047244094488189, "rgb(47, 47, 47)"],
  [0.20866141732283464, "rgb(43, 43, 43)"],
  [0.2125984251968504, "rgb(39, 39, 39)"],
  [0.21653543307086615, "rgb(34, 34, 34)"],
  [0.2204724409448819, "rgb(31, 31, 31)"],
  [0.22440944881889763, "rgb(27, 27, 27)"],
  [0.22834645669291337, "rgb(23, 23, 23)"],
  [0.23228346456692914, "rgb(18, 18, 18)"],
  [0.23622047244094488, "rgb(15, 15, 15)"],
  [0.24015748031496062, "rgb(11, 11, 11)"],
  [0.2440944881889764, "rgb(7, 7, 7)"],
  [0.24803149606299213, "rgb(2, 2, 2)"],
  [0.25196850393700787, "rgb(1, 0, 0)"],
  [0.2559055118110236, "rgb(6, 0, 0)"],
  [0.25984251968503935, "rgb(11, 0, 0)"],
  [0.2637795275590551, "rgb(17, 0, 0)"],
  [0.26771653543307083, "rgb(22, 0, 0)"],
  [0.27165354330708663, "rgb(28, 0, 0)"],
  [0.2755905511811024, "rgb(33, 0, 0)"],
  [0.2795275590551181, "rgb(38, 0, 0)"],
  [0.28346456692913385, "rgb(44, 0, 0)"],
  [0.2874015748031496, "rgb(49, 0, 0)"],
  [0.29133858267716534, "rgb(54, 0, 0)"],
  [0.2952755905511811, "rgb(60, 0, 0)"],
  [0.2992125984251969, "rgb(65, 0, 0)"],
  [0.3031496062992126, "rgb(70, 0, 0)"],
  [0.30708661417322836, "rgb(76, 0, 0)"],
  [0.3110236220472441, "rgb(81, 0, 0)"],
  [0.31496062992125984, "rgb(86, 0, 0)"],
  [0.3188976377952756, "rgb(92, 0, 0)"],
  [0.3228346456692913, "rgb(97, 0, 0)"],
  [0.32677165354330706, "rgb(102, 0, 0)"],
  [0.3307086614173228, "rgb(108, 0, 0)"],
  [0.3346456692913386, "rgb(113, 0, 0)"],
  [0.33858267716535434, "rgb(118, 0, 0)"],
  [0.3425196850393701, "rgb(124, 0, 0)"],
  [0.3464566929133858, "rgb(129, 0, 0)"],
  [0.35039370078740156, "rgb(134, 0, 0)"],
  [0.3543307086614173, "rgb(139, 0, 0)"],
  [0.35826771653543305, "rgb(145, 0, 0)"],
  [0.36220472440944884, "rgb(150, 0, 0)"],
  [0.3661417322834646, "rgb(156, 0, 0)"],
  [0.3700787401574803, "rgb(161, 0, 0)"],
  [0.37401574803149606, "rgb(166, 0, 0)"],
  [0.3779527559055118, "rgb(172, 0, 0)"],
  [0.38188976377952755, "rgb(177, 0, 0)"],
  [0.3858267716535433, "rgb(182, 0, 0)"],
  [0.38976377952755903, "rgb(188, 0, 0)"],
  [0.39370078740157477, "rgb(193, 0, 0)"],
  [0.39763779527559057, "rgb(198, 0, 0)"],
  [0.4015748031496063, "rgb(204, 0, 0)"],
  [0.40551181102362205, "rgb(209, 0, 0)"],
  [0.4094488188976378, "rgb(214, 0, 0)"],
  [0.41338582677165353, "rgb(220, 0, 0)"],
  [0.41732283464566927, "rgb(225, 0, 0)"],
  [0.421259842519685, "rgb(230, 0, 0)"],
  [0.4251968503937008, "rgb(236, 0, 0)"],
  [0.42913385826771655, "rgb(241, 0, 0)"],
  [0.4330708661417323, "rgb(246, 0, 0)"],
  [0.43700787401574803, "rgb(252, 0, 0)"],
  [0.4409448818897638, "rgb(255, 2, 0)"],
  [0.4448818897637795, "rgb(255, 7, 0)"],
  [0.44881889763779526, "rgb(255, 12, 0)"],
  [0.452755905511811, "rgb(255, 18, 0)"],
  [0.45669291338582674, "rgb(255, 23, 0)"],
  [0.46062992125984253, "rgb(255, 29, 0)"],
  [0.4645669291338583, "rgb(255, 34, 0)"],
  [0.468503937007874, "rgb(255, 39, 0)"],
  [0.47244094488188976, "rgb(255, 45, 0)"],
  [0.4763779527559055, "rgb(255, 50, 0)"],
  [0.48031496062992124, "rgb(255, 55, 0)"],
  [0.484251968503937, "rgb(255, 61, 0)"],
  [0.4881889763779528, "rgb(255, 66, 0)"],
  [0.4921259842519685, "rgb(255, 71, 0)"],
  [0.49606299212598426, "rgb(255, 77, 0)"],
  [0.5, "rgb(255, 87, 0)"],
  [0.5039370078740157, "rgb(255, 93, 0)"],
  [0.5078740157480315, "rgb(255, 98, 0)"],
  [0.5118110236220472, "rgb(255, 103, 0)"],
  [0.515748031496063, "rgb(255, 108, 0)"],
  [0.5196850393700787, "rgb(255, 114, 0)"],
  [0.5236220472440944, "rgb(255, 119, 0)"],
  [0.5275590551181102, "rgb(255, 125, 0)"],
  [0.5314960629921259, "rgb(255, 130, 0)"],
  [0.5354330708661417, "rgb(255, 135, 0)"],
  [0.5393700787401575, "rgb(255, 141, 0)"],
  [0.5433070866141733, "rgb(255, 146, 0)"],
  [0.547244094488189, "rgb(255, 151, 0)"],
  [0.5511811023622047, "rgb(255, 157, 0)"],
  [0.5551181102362205, "rgb(255, 162, 0)"],
  [0.5590551181102362, "rgb(255, 167, 0)"],
  [0.562992125984252, "rgb(255, 173, 0)"],
  [0.5669291338582677, "rgb(255, 178, 0)"],
  [0.5708661417322834, "rgb(255, 183, 0)"],
  [0.5748031496062992, "rgb(255, 189, 0)"],
  [0.5787401574803149, "rgb(255, 194, 0)"],
  [0.5826771653543307, "rgb(255, 199, 0)"],
  [0.5866141732283464, "rgb(255, 205, 0)"],
  [0.5905511811023622, "rgb(255, 210, 0)"],
  [0.5944881889763779, "rgb(255, 215, 0)"],
  [0.5984251968503937, "rgb(255, 221, 0)"],
  [0.6023622047244095, "rgb(255, 226, 0)"],
  [0.6062992125984252, "rgb(255, 231, 0)"],
  [0.610236220472441, "rgb(255, 237, 0)"],
  [0.6141732283464567, "rgb(255, 242, 0)"],
  [0.6181102362204725, "rgb(255, 247, 0)"],
  [0.6220472440944882, "rgb(255, 253, 0)"],
  [0.6259842519685039, "rgb(255, 255, 1)"],
  [0.6299212598425197, "rgb(255, 255, 4)"],
  [0.6338582677165354, "rgb(255, 255, 7)"],
  [0.6377952755905512, "rgb(255, 255, 9)"],
  [0.6417322834645669, "rgb(255, 255, 12)"],
  [0.6456692913385826, "rgb(255, 255, 15)"],
  [0.6496062992125984, "rgb(255, 255, 17)"],
  [0.6535433070866141, "rgb(255, 255, 20)"],
  [0.6574803149606299, "rgb(255, 255, 23)"],
  [0.6614173228346456, "rgb(255, 255, 25)"],
  [0.6653543307086615, "rgb(255, 255, 28)"],
  [0.6692913385826772, "rgb(255, 255, 31)"],
  [0.6732283464566929, "rgb(255, 255, 33)"],
  [0.6771653543307087, "rgb(255, 255, 36)"],
  [0.6811023622047244, "rgb(255, 255, 39)"],
  [0.6850393700787402, "rgb(255, 255, 41)"],
  [0.6889763779527559, "rgb(255, 255, 44)"],
  [0.6929133858267716, "rgb(255, 255, 47)"],
  [0.6968503937007874, "rgb(255, 255, 49)"],
  [0.7007874015748031, "rgb(255, 255, 52)"],
  [0.7047244094488189, "rgb(255, 255, 54)"],
  [0.7086614173228346, "rgb(255, 255, 57)"],
  [0.7125984251968503, "rgb(255, 255, 60)"],
  [0.7165354330708661, "rgb(255, 255, 63)"],
  [0.7204724409448818, "rgb(255, 255, 65)"],
  [0.7244094488188977, "rgb(255, 255, 68)"],
  [0.7283464566929134, "rgb(255, 255, 71)"],
  [0.7322834645669292, "rgb(255, 255, 73)"],
  [0.7362204724409449, "rgb(255, 255, 76)"],
  [0.7401574803149606, "rgb(255, 255, 79)"],
  [0.7440944881889764, "rgb(255, 255, 81)"],
  [0.7480314960629921, "rgb(255, 255, 84)"],
  [0.7519685039370079, "rgb(255, 255, 87)"],
  [0.7559055118110236, "rgb(255, 255, 89)"],
  [0.7598425196850394, "rgb(255, 255, 92)"],
  [0.7637795275590551, "rgb(255, 255, 95)"],
  [0.7677165354330708, "rgb(255, 255, 97)"],
  [0.7716535433070866, "rgb(255, 255, 100)"],
  [0.7755905511811023, "rgb(255, 255, 103)"],
  [0.7795275590551181, "rgb(255, 255, 105)"],
  [0.7834645669291338, "rgb(255, 255, 108)"],
  [0.7874015748031495, "rgb(255, 255, 111)"],
  [0.7913385826771654, "rgb(255, 255, 113)"],
  [0.7952755905511811, "rgb(255, 255, 116)"],
  [0.7992125984251969, "rgb(255, 255, 119)"],
  [0.8031496062992126, "rgb(255, 255, 121)"],
  [0.8070866141732284, "rgb(255, 255, 124)"],
  [0.8110236220472441, "rgb(255, 255, 127)"],
  [0.8149606299212598, "rgb(255, 255, 129)"],
  [0.8188976377952756, "rgb(255, 255, 132)"],
  [0.8228346456692913, "rgb(255, 255, 135)"],
  [0.8267716535433071, "rgb(255, 255, 137)"],
  [0.8307086614173228, "rgb(255, 255, 140)"],
  [0.8346456692913385, "rgb(255, 255, 143)"],
  [0.8385826771653543, "rgb(255, 255, 145)"],
  [0.84251968503937, "rgb(255, 255, 148)"],
  [0.8464566929133858, "rgb(255, 255, 151)"],
  [0.8503937007874016, "rgb(255, 255, 153)"],
  [0.8543307086614174, "rgb(255, 255, 156)"],
  [0.8582677165354331, "rgb(255, 255, 159)"],
  [0.8622047244094488, "rgb(255, 255, 161)"],
  [0.8661417322834646, "rgb(255, 255, 164)"],
  [0.8700787401574803, "rgb(255, 255, 167)"],
  [0.8740157480314961, "rgb(255, 255, 169)"],
  [0.8779527559055118, "rgb(255, 255, 172)"],
  [0.8818897637795275, "rgb(255, 255, 175)"],
  [0.8858267716535433, "rgb(255, 255, 177)"],
  [0.889763779527559, "rgb(255, 255, 180)"],
  [0.8937007874015748, "rgb(255, 255, 182)"],
  [0.8976377952755905, "rgb(255, 255, 185)"],
  [0.9015748031496063, "rgb(255, 255, 188)"],
  [0.905511811023622, "rgb(255, 255, 191)"],
  [0.9094488188976377, "rgb(255, 255, 193)"],
  [0.9133858267716535, "rgb(255, 255, 196)"],
  [0.9173228346456693, "rgb(255, 255, 199)"],
  [0.9212598425196851, "rgb(255, 255, 201)"],
  [0.9251968503937008, "rgb(255, 255, 204)"],
  [0.9291338582677166, "rgb(255, 255, 207)"],
  [0.9330708661417323, "rgb(255, 255, 209)"],
  [0.937007874015748, "rgb(255, 255, 212)"],
  [0.9409448818897638, "rgb(255, 255, 215)"],
  [0.9448818897637795, "rgb(255, 255, 217)"],
  [0.9488188976377953, "rgb(255, 255, 220)"],
  [0.952755905511811, "rgb(255, 255, 223)"],
  [0.9566929133858267, "rgb(255, 255, 225)"],
  [0.9606299212598425, "rgb(255, 255, 228)"],
  [0.9645669291338582, "rgb(255, 255, 231)"],
  [0.968503937007874, "rgb(255, 255, 233)"],
  [0.9724409448818897, "rgb(255, 255, 236)"],
  [0.9763779527559056, "rgb(255, 255, 239)"],
  [0.9803149606299213, "rgb(255, 255, 241)"],
  [0.984251968503937, "rgb(255, 255, 244)"],
  [0.9881889763779528, "rgb(255, 255, 247)"],
  [0.9921259842519685, "rgb(255, 255, 249)"],
  [0.9960629921259843, "rgb(255, 255, 252)"],
  [1, "rgb(255, 255, 255)"]
];

export const VISC_COLORSCALE: [number, string][] = [
  [0, "rgb(114, 114, 114)"],
  [0.00392156862745098, "rgb(114, 255, 113)"],
  [0.00784313725490196, "rgb(115, 254, 112)"],
  [0.011764705882352941, "rgb(115, 254, 112)"],
  [0.01568627450980392, "rgb(116, 254, 111)"],
  [0.0196078431372549, "rgb(116, 254, 111)"],
  [0.023529411764705882, "rgb(117, 254, 110)"],
  [0.027450980392156862, "rgb(117, 254, 110)"],
  [0.03137254901960784, "rgb(118, 254, 109)"],
  [0.03529411764705882, "rgb(118, 254, 109)"],
  [0.0392156862745098, "rgb(119, 254, 108)"],
  [0.043137254901960784, "rgb(119, 254, 108)"],
  [0.047058823529411764, "rgb(120, 254, 107)"],
  [0.050980392156862744, "rgb(120, 254, 107)"],
  [0.054901960784313725, "rgb(121, 254, 106)"],
  [0.058823529411764705, "rgb(121, 254, 106)"],
  [0.06274509803921569, "rgb(122, 254, 105)"],
  [0.06666666666666667, "rgb(122, 254, 105)"],
  [0.07058823529411765, "rgb(123, 254, 104)"],
  [0.07450980392156863, "rgb(123, 254, 104)"],
  [0.0784313725490196, "rgb(124, 254, 103)"],
  [0.08235294117647059, "rgb(124, 254, 103)"],
  [0.08627450980392157, "rgb(125, 254, 102)"],
  [0.09019607843137255, "rgb(126, 254, 102)"],
  [0.09411764705882353, "rgb(126, 254, 101)"],
  [0.09803921568627451, "rgb(127, 254, 101)"],
  [0.10196078431372549, "rgb(127, 254, 100)"],
  [0.10588235294117647, "rgb(128, 254, 99)"],
  [0.10980392156862745, "rgb(128, 254, 99)"],
  [0.11372549019607843, "rgb(129, 254, 98)"],
  [0.11764705882352941, "rgb(129, 254, 98)"],
  [0.12156862745098039, "rgb(130, 254, 97)"],
  [0.12549019607843137, "rgb(130, 254, 97)"],
  [0.12941176470588237, "rgb(131, 253, 96)"],
  [0.13333333333333333, "rgb(131, 253, 96)"],
  [0.13725490196078433, "rgb(132, 253, 95)"],
  [0.1411764705882353, "rgb(132, 253, 95)"],
  [0.1450980392156863, "rgb(133, 253, 94)"],
  [0.14901960784313725, "rgb(133, 253, 94)"],
  [0.15294117647058825, "rgb(134, 253, 93)"],
  [0.1568627450980392, "rgb(134, 253, 93)"],
  [0.1607843137254902, "rgb(135, 253, 92)"],
  [0.16470588235294117, "rgb(135, 253, 92)"],
  [0.16862745098039217, "rgb(136, 253, 91)"],
  [0.17254901960784313, "rgb(136, 253, 91)"],
  [0.17647058823529413, "rgb(137, 253, 90)"],
  [0.1803921568627451, "rgb(137, 252, 90)"],
  [0.1843137254901961, "rgb(138, 252, 89)"],
  [0.18823529411764706, "rgb(138, 252, 89)"],
  [0.19215686274509805, "rgb(139, 252, 88)"],
  [0.19607843137254902, "rgb(139, 252, 88)"],
  [0.2, "rgb(140, 252, 87)"],
  [0.20392156862745098, "rgb(140, 252, 87)"],
  [0.20784313725490197, "rgb(141, 252, 86)"],
  [0.21176470588235294, "rgb(141, 252, 86)"],
  [0.21568627450980393, "rgb(142, 252, 85)"],
  [0.2196078431372549, "rgb(143, 251, 85)"],
  [0.2235294117647059, "rgb(143, 251, 84)"],
  [0.22745098039215686, "rgb(144, 251, 84)"],
  [0.23137254901960785, "rgb(144, 251, 83)"],
  [0.23529411764705882, "rgb(145, 251, 83)"],
  [0.23921568627450981, "rgb(145, 251, 82)"],
  [0.24313725490196078, "rgb(146, 251, 82)"],
  [0.24705882352941178, "rgb(146, 251, 81)"],
  [0.25098039215686274, "rgb(147, 251, 81)"],
  [0.2549019607843137, "rgb(147, 250, 80)"],
  [0.25882352941176473, "rgb(148, 250, 79)"],
  [0.2627450980392157, "rgb(148, 250, 79)"],
  [0.26666666666666666, "rgb(149, 250, 78)"],
  [0.27058823529411763, "rgb(149, 250, 78)"],
  [0.27450980392156865, "rgb(150, 250, 77)"],
  [0.2784313725490196, "rgb(150, 250, 77)"],
  [0.2823529411764706, "rgb(151, 250, 76)"],
  [0.28627450980392155, "rgb(151, 249, 76)"],
  [0.2901960784313726, "rgb(152, 249, 75)"],
  [0.29411764705882354, "rgb(152, 249, 75)"],
  [0.2980392156862745, "rgb(153, 249, 74)"],
  [0.30196078431372547, "rgb(153, 249, 74)"],
  [0.3058823529411765, "rgb(154, 249, 73)"],
  [0.30980392156862746, "rgb(154, 249, 73)"],
  [0.3137254901960784, "rgb(155, 248, 72)"],
  [0.3176470588235294, "rgb(155, 248, 72)"],
  [0.3215686274509804, "rgb(156, 248, 71)"],
  [0.3254901960784314, "rgb(156, 248, 71)"],
  [0.32941176470588235, "rgb(157, 248, 70)"],
  [0.3333333333333333, "rgb(157, 248, 70)"],
  [0.33725490196078434, "rgb(158, 247, 69)"],
  [0.3411764705882353, "rgb(158, 247, 69)"],
  [0.34509803921568627, "rgb(159, 247, 68)"],
  [0.34901960784313724, "rgb(159, 247, 68)"],
  [0.35294117647058826, "rgb(160, 247, 68)"],
  [0.3568627450980392, "rgb(160, 247, 67)"],
  [0.3607843137254902, "rgb(161, 246, 67)"],
  [0.36470588235294116, "rgb(161, 246, 66)"],
  [0.3686274509803922, "rgb(162, 246, 66)"],
  [0.37254901960784315, "rgb(162, 246, 65)"],
  [0.3764705882352941, "rgb(163, 246, 65)"],
  [0.3803921568627451, "rgb(163, 246, 64)"],
  [0.3843137254901961, "rgb(163, 245, 64)"],
  [0.38823529411764707, "rgb(164, 245, 63)"],
  [0.39215686274509803, "rgb(164, 245, 63)"],
  [0.396078431372549, "rgb(165, 245, 62)"],
  [0.4, "rgb(165, 245, 62)"],
  [0.403921568627451, "rgb(166, 244, 61)"],
  [0.40784313725490196, "rgb(166, 244, 61)"],
  [0.4117647058823529, "rgb(167, 244, 60)"],
  [0.41568627450980394, "rgb(167, 244, 60)"],
  [0.4196078431372549, "rgb(168, 244, 59)"],
  [0.4235294117647059, "rgb(168, 243, 59)"],
  [0.42745098039215684, "rgb(169, 243, 58)"],
  [0.43137254901960786, "rgb(169, 243, 58)"],
  [0.43529411764705883, "rgb(170, 243, 57)"],
  [0.4392156862745098, "rgb(170, 243, 57)"],
  [0.44313725490196076, "rgb(171, 242, 56)"],
  [0.4470588235294118, "rgb(171, 242, 56)"],
  [0.45098039215686275, "rgb(172, 242, 55)"],
  [0.4549019607843137, "rgb(172, 242, 55)"],
  [0.4588235294117647, "rgb(173, 242, 54)"],
  [0.4627450980392157, "rgb(173, 241, 54)"],
  [0.4666666666666667, "rgb(174, 241, 54)"],
  [0.47058823529411764, "rgb(174, 241, 53)"],
  [0.4745098039215686, "rgb(174, 241, 53)"],
  [0.47843137254901963, "rgb(175, 240, 52)"],
  [0.4823529411764706, "rgb(175, 240, 52)"],
  [0.48627450980392156, "rgb(176, 240, 51)"],
  [0.49019607843137253, "rgb(176, 240, 51)"],
  [0.49411764705882355, "rgb(177, 239, 50)"],
  [0.4980392156862745, "rgb(177, 239, 50)"],
  [0.5019607843137255, "rgb(178, 239, 49)"],
  [0.5058823529411764, "rgb(178, 239, 49)"],
  [0.5098039215686274, "rgb(179, 239, 48)"],
  [0.5137254901960784, "rgb(179, 238, 48)"],
  [0.5176470588235295, "rgb(180, 238, 47)"],
  [0.5215686274509804, "rgb(180, 238, 47)"],
  [0.5254901960784314, "rgb(181, 238, 47)"],
  [0.5294117647058824, "rgb(181, 237, 46)"],
  [0.5333333333333333, "rgb(181, 237, 46)"],
  [0.5372549019607843, "rgb(182, 237, 45)"],
  [0.5411764705882353, "rgb(182, 237, 45)"],
  [0.5450980392156862, "rgb(183, 236, 44)"],
  [0.5490196078431373, "rgb(183, 236, 44)"],
  [0.5529411764705883, "rgb(184, 236, 43)"],
  [0.5568627450980392, "rgb(184, 236, 43)"],
  [0.5607843137254902, "rgb(185, 235, 42)"],
  [0.5647058823529412, "rgb(185, 235, 42)"],
  [0.5686274509803921, "rgb(186, 235, 42)"],
  [0.5725490196078431, "rgb(186, 234, 41)"],
  [0.5764705882352941, "rgb(186, 234, 41)"],
  [0.5803921568627451, "rgb(187, 234, 40)"],
  [0.5843137254901961, "rgb(187, 234, 40)"],
  [0.5882352941176471, "rgb(188, 233, 39)"],
  [0.592156862745098, "rgb(188, 233, 39)"],
  [0.596078431372549, "rgb(189, 233, 38)"],
  [0.6, "rgb(189, 233, 38)"],
  [0.6039215686274509, "rgb(190, 232, 38)"],
  [0.6078431372549019, "rgb(190, 232, 37)"],
  [0.611764705882353, "rgb(190, 232, 37)"],
  [0.615686274509804, "rgb(191, 231, 36)"],
  [0.6196078431372549, "rgb(191, 231, 36)"],
  [0.6235294117647059, "rgb(192, 231, 35)"],
  [0.6274509803921569, "rgb(192, 231, 35)"],
  [0.6313725490196078, "rgb(193, 230, 35)"],
  [0.6352941176470588, "rgb(193, 230, 34)"],
  [0.6392156862745098, "rgb(193, 230, 34)"],
  [0.6431372549019608, "rgb(194, 229, 33)"],
  [0.6470588235294118, "rgb(194, 229, 33)"],
  [0.6509803921568628, "rgb(195, 229, 32)"],
  [0.6549019607843137, "rgb(195, 228, 32)"],
  [0.6588235294117647, "rgb(196, 228, 32)"],
  [0.6627450980392157, "rgb(196, 228, 31)"],
  [0.6666666666666666, "rgb(196, 228, 31)"],
  [0.6705882352941176, "rgb(197, 227, 30)"],
  [0.6745098039215687, "rgb(197, 227, 30)"],
  [0.6784313725490196, "rgb(198, 227, 29)"],
  [0.6823529411764706, "rgb(198, 226, 29)"],
  [0.6862745098039216, "rgb(198, 226, 29)"],
  [0.6901960784313725, "rgb(199, 226, 28)"],
  [0.6941176470588235, "rgb(199, 225, 28)"],
  [0.6980392156862745, "rgb(200, 225, 27)"],
  [0.7019607843137254, "rgb(200, 225, 27)"],
  [0.7058823529411765, "rgb(201, 224, 27)"],
  [0.7098039215686275, "rgb(201, 224, 26)"],
  [0.7137254901960784, "rgb(201, 224, 26)"],
  [0.7176470588235294, "rgb(202, 223, 25)"],
  [0.7215686274509804, "rgb(202, 223, 25)"],
  [0.7254901960784313, "rgb(203, 223, 24)"],
  [0.7294117647058823, "rgb(203, 222, 24)"],
  [0.7333333333333333, "rgb(203, 222, 24)"],
  [0.7372549019607844, "rgb(204, 222, 23)"],
  [0.7411764705882353, "rgb(204, 221, 23)"],
  [0.7450980392156863, "rgb(205, 221, 22)"],
  [0.7490196078431373, "rgb(205, 221, 22)"],
  [0.7529411764705882, "rgb(205, 220, 22)"],
  [0.7568627450980392, "rgb(206, 220, 21)"],
  [0.7607843137254902, "rgb(206, 220, 21)"],
  [0.7647058823529411, "rgb(207, 219, 21)"],
  [0.7686274509803922, "rgb(207, 219, 20)"],
  [0.7725490196078432, "rgb(207, 219, 20)"],
  [0.7764705882352941, "rgb(208, 218, 19)"],
  [0.7803921568627451, "rgb(208, 218, 19)"],
  [0.7843137254901961, "rgb(209, 218, 19)"],
  [0.788235294117647, "rgb(209, 217, 18)"],
  [0.792156862745098, "rgb(209, 217, 18)"],
  [0.796078431372549, "rgb(210, 217, 17)"],
  [0.8, "rgb(210, 216, 17)"],
  [0.803921568627451, "rgb(210, 216, 17)"],
  [0.807843137254902, "rgb(211, 216, 16)"],
  [0.8117647058823529, "rgb(211, 215, 16)"],
  [0.8156862745098039, "rgb(212, 215, 16)"],
  [0.8196078431372549, "rgb(212, 214, 15)"],
  [0.8235294117647058, "rgb(212, 214, 15)"],
  [0.8274509803921568, "rgb(213, 214, 14)"],
  [0.8313725490196079, "rgb(213, 213, 14)"],
  [0.8352941176470589, "rgb(213, 213, 14)"],
  [0.8392156862745098, "rgb(214, 213, 13)"],
  [0.8431372549019608, "rgb(214, 212, 13)"],
  [0.8470588235294118, "rgb(214, 212, 13)"],
  [0.8509803921568627, "rgb(215, 212, 12)"],
  [0.8549019607843137, "rgb(215, 211, 12)"],
  [0.8588235294117647, "rgb(216, 211, 11)"],
  [0.8627450980392157, "rgb(216, 210, 11)"],
  [0.8666666666666667, "rgb(216, 210, 11)"],
  [0.8705882352941177, "rgb(217, 210, 10)"],
  [0.8745098039215686, "rgb(217, 209, 10)"],
  [0.8784313725490196, "rgb(217, 209, 10)"],
  [0.8823529411764706, "rgb(218, 209, 9)"],
  [0.8862745098039215, "rgb(218, 208, 9)"],
  [0.8901960784313725, "rgb(218, 208, 9)"],
  [0.8941176470588236, "rgb(219, 207, 8)"],
  [0.8980392156862745, "rgb(219, 207, 8)"],
  [0.9019607843137255, "rgb(219, 207, 8)"],
  [0.9058823529411765, "rgb(220, 206, 7)"],
  [0.9098039215686274, "rgb(220, 206, 7)"],
  [0.9137254901960784, "rgb(220, 205, 7)"],
  [0.9176470588235294, "rgb(221, 205, 6)"],
  [0.9215686274509803, "rgb(221, 205, 6)"],
  [0.9254901960784314, "rgb(221, 204, 6)"],
  [0.9294117647058824, "rgb(222, 204, 5)"],
  [0.9333333333333333, "rgb(222, 203, 5)"],
  [0.9372549019607843, "rgb(222, 203, 5)"],
  [0.9411764705882353, "rgb(223, 203, 4)"],
  [0.9450980392156862, "rgb(223, 202, 4)"],
  [0.9490196078431372, "rgb(223, 202, 4)"],
  [0.9529411764705882, "rgb(224, 201, 3)"],
  [0.9568627450980393, "rgb(224, 201, 3)"],
  [0.9607843137254902, "rgb(224, 201, 3)"],
  [0.9647058823529412, "rgb(225, 200, 2)"],
  [0.9686274509803922, "rgb(225, 200, 2)"],
  [0.9725490196078431, "rgb(225, 199, 2)"],
  [0.9764705882352941, "rgb(226, 199, 1)"],
  [0.9803921568627451, "rgb(226, 198, 1)"],
  [0.984313725490196, "rgb(226, 198, 1)"],
  [0.9882352941176471, "rgb(227, 198, 0)"],
  [0.9921568627450981, "rgb(227, 197, 0)"],
  [0.996078431372549, "rgb(227, 197, 0)"],
  [1, "rgb(228, 196, 0)"]
];
